<template>
  <div class="py-4 flex flex-col gap-y-4 items-center justify-between sm:(py-6 flex-row)">
    <IcsLogo class="heading-link-bright text-center svg:(mx-auto w-40 sm:w-auto) sm:text-left">
      <component
        :is="$route.path === '/' ? 'h1' : 'div'"
        class="mt-2 flex uppercase transition-color f-text-18-22 f-leading-24-32 font-flex-520-151-528"
      >
        Integrated Cable Systems
      </component>
      <!-- <ConnectedByTrexon class="mt-2 f-max-w-170-208 sm:!mr-0" /> -->
      <div class="mt-2 flex justify-center sm:justify-end">
        <img
          src="/ics-logo-amphenol-tag.png"
          class="w-40 sm:w-56"
        >
      </div>
    </IcsLogo>
    <div class="text-icsblue font-500 grid grid-flow-col w-full items-center f-text-15-20 dark:text-icscyan-300 sm:grid-flow-row sm:w-auto">
      <div class="flex items-center f-mb-4-8 f-gap-6-12 sm:justify-end">
        <div class="i-carbon-certificate bg-gradient-icsbluecyan sm:scale-120" />
        <div class="leading-tight whitespace-nowrap">
          ISO 9001:2015 & AS9100D Certified
        </div>
      </div>
      <div class="flex items-center f-gap-6-12 sm:justify-end">
        <div class="i-carbon-phone bg-gradient-icsbluecyan sm:scale-120" />
        <div>1-720-652-6777</div>
      </div>
      <div class="flex flex-wrap gap-x-3 row-span-2 justify-right justify-self-end media-[(pointer:fine)]:gap-y-2 sm:row-span-1 sm:f-mt-12-24">
        <ATooltip
          text="Toggle color mode"
          pos="left"
        >
          <ButtonThemeToggle
            size="fluid"
            icon-only
          />
        </ATooltip>
        <AButton
          label="Get Quote"
          color="blue"
          size="fluid"
          icon="i-carbon-task-tools"
          to="/contact/rfq"
        />
      </div>
    </div>
  </div>
</template>
